module.exports = __webpack_public_path__ + "img/Flächenbrand.722dde8f.svg";